import { BaseRequiredDialogProps as DialogBaseRequiredProps } from '@bloomfieldrobotics/canopy';
import { UnitsEnum } from '../../../../../services/entities/impl/blfApi/apiConstants';
import { useTranslation } from '../../../../../services/translation/hooks/useTranslation';
import { DataGridDialogWithDownload } from '../../../../commonUI/DataGridDialogWithDownload';
import { createExportFileName } from '../../../../dataGridTables/utils/createExportFileName';
import { BlueberrySizeTable } from '../BlueberrySizeTable';

export const BlueberrySizeTableDialog = ({
  open: isOpen,
  onClose,
}: DialogBaseRequiredProps) => {
  const { t } = useTranslation();

  return (
    <DataGridDialogWithDownload
      open={isOpen}
      onClose={onClose}
      title={t('Fruit Size')}
      GridComponent={BlueberrySizeTable}
      exportFileName={createExportFileName(
        'Blueberry Sizing Summary',
        t,
        UnitsEnum.metric
      )}
    />
  );
};
